import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getListReports, changeReportAdmin } from '../../actions/reportActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const ReportUserAdmin = ({ history, getListReports, isLoadingListReports, changeReportAdmin, listOfReports }) => {


    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getListReports({ status: 0 })
        })
        
    },[])
    console.log()
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [strikeQuantity, setStrikeQuantity] = useState('')
    const [banDays, setBanDays] = useState('')
    const [newBanDays, setNewBanDays] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isLimit, setIsLimit] = useState(false)
    const [existActualLimit, setExistActualLimit] = useState(null)



    console.log()
    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }
    useEffect(() => {
        if (strikeQuantity !== '' && banDays !== '' && isLimit === false) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                ['banDays']: ''
            }));
        }
        if (strikeQuantity !== '' && isLimit === true) {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                ['banDays']: ''
            }));
        }

        if ((strikeQuantity === '' || banDays === '') && isLimit === false) {
            setValidate(false)
        }
    }, [isLimit])

    const isChecked = () => {
        console.log()
        setIsLimit(!isLimit)
        console.log()

    }

    const isEmpty = (e) => {
        console.log()
        const { name, placeholder, value } = e.target;
        if (strikeQuantity !== '' && banDays !== '' && isLimit === false) {
            setValidate(true)

        }

        if (strikeQuantity !== '' && isLimit === true) {
            setValidate(true)

        }

        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{'Lista de reportados'}</div>
                <div className="container-inputs-new-mark">
                {/* 
                    <button className='mb-3 btns-admin parent-width p-3' onClick={() => { getListReports({ reportState: 0 }) }}>Ver reportados</button> */}
                    <button className='mb-3 btns-admin parent-width p-3' onClick={() => { getListReports({ status: 1 }) }}>En espera decisión usuario reportado</button>
                {/*     <button className='mb-3 btns-admin parent-width p-3' onClick={() => { getListReports({ reportState: 2 }) }}>Olvidado por usuario reportado</button>  */}
                  {/*   <button className='mb-3 btns-admin parent-width p-3' onClick={() => { getListReports({ status: 3 }) }}>En revisión por Administrador</button> */}
                    <button className='mb-3 btns-admin parent-width p-3' onClick={() => { getListReports({ status: 2 }) }}>Omitido (No infringe normas)</button>
                    <button className='mb-3 btns-admin parent-width p-3' onClick={() => { getListReports({ status: 3 }) }}>Bloqueado (Si infringe normas)</button>

                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Lista de reportes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListReports ? <div>Cargando...</div> :
                        listOfReports && listOfReports.map((report, index) => (
                            <div key={report._id} className="card-admin">
                              
                                <div className="text-content-card">{report.reportedUserID.name} {report.reportedUserID.lastname}</div> 
                                {report.descriptions.length>0 && <div className="text-content-card">{report.descriptions[0].message}</div>}
                                {( report.status ===0) && <div className="column">
                                    <button className="btn-red ml-1" onClick={() => { changeReportAdmin({ entityReportID: report._id, status: 3 }) }}>Infringe las normas</button>
                                    <button className="btn-blue btns-admin ml-1" onClick={() => { changeReportAdmin({ entityReportID: report._id, status: 2 }) }}>No infringe las normas</button>

                                </div>}
                            </div>
                        ))
                    }
                </div>

            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListReports: state.postAdmin.isLoadingListReports,
        listOfReports: state.postAdmin.listOfReports
    }
}


export default connect(mapStateToProps, { getListReports, changeReportAdmin })(ReportUserAdmin)